// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2p8av","obliqueLineWrap":"membershipbadge_obliqueLineWrap__pfK0l","obliqueLine":"membershipbadge_obliqueLine__5xeRv"};